import 'jquery-zoom';

$('#slick-product .zoom-wp').each((_, elm) => {
  $(elm).zoom();
});
